export default "__VITE_ASSET__663e9d2f__"